import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useSelectorApp } from "../../../lib/redux";
import {
  ADLE_DOMAIN,
  BUZZLY_DOMAIN,
  IS_ADLE_DOMAIN,
} from "../../../utils/constants";

const Navbar = ({ compact = false }) => {
  const { theme } = useSelectorApp((state) => state.ui);

  return (
    <Box
      component="nav"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: compact ? 0 : 3,
        "@media (max-width: 480px)": {
          gap: compact ? 0 : "8px",
          alignItems: compact ? "center" : "flex-start",
          flexDirection: compact ? "row" : "column",
        },
      }}
    >
      <Avatar
        src={theme.logoLogin}
        alt="Logo"
        variant="square"
        sx={{
          width: "fit-content",
          height: compact ? { xs: "36px", sm: "44px" } : "52px",
          backgroundColor: "transparent",
          borderRadius: 0,
          overflow: "visible",
          ".MuiAvatar-img": {
            width: "auto",
            height: "100%",
            maxWidth: compact ? { xs: "120px", sm: "155px" } : "155px",
            objectFit: "contain",
            objectPosition: "left center",
          },
        }}
      />
      <Typography
        sx={{
          fontSize: compact ? { xs: "12px", sm: "14px" } : "14px",
          color: "text.secondary",
          display: compact ? { xs: "none", sm: "block" } : "block",
        }}
      >
        {IS_ADLE_DOMAIN ? ADLE_DOMAIN : BUZZLY_DOMAIN}
      </Typography>
    </Box>
  );
};

export default Navbar;
